/* <kik-swiper>: a single viewport-aware lifecycle; the layout owns Swiper. */
if (!customElements.get('kik-swiper')) {
  class KikSwiper extends HTMLElement {
    connectedCallback() {
      if (this.cancelMount) return;
      const container = this.querySelector('.swiper');
      if (!container || !window.kikMountSwiper) return;
      this.cancelMount = window.kikMountSwiper(this, () => {
        let config = {};
        try {
          config = JSON.parse(this.querySelector('script[type="application/json"]')?.textContent || '{}');
        } catch (error) {
          console.warn('[kik-swiper] invalid JSON config — using defaults.', error);
        }
        if (config.navigation) {
          for (const key of ['nextEl', 'prevEl']) {
            if (typeof config.navigation[key] === 'string') config.navigation[key] = this.querySelector(config.navigation[key]);
          }
        }
        if (typeof config.pagination?.el === 'string') config.pagination.el = this.querySelector(config.pagination.el);
        this.swiper = new window.Swiper(container, config);
        return this.swiper;
      });
    }
    disconnectedCallback() {
      this.cancelMount?.();
      this.cancelMount = null;
      this.swiper = null;
    }
  }
  customElements.define('kik-swiper', KikSwiper);
}
